import React from 'react'
import _ from 'lodash'

import {Alert, Button, Icon, Select} from 'antd'

import {Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

import {OrganizationStore} from 'api/organization'
import {NetworkService} from 'api/network'
import {AuthStore} from 'api/auth'

// find all known entities from network, then scan all organization for the
// rest
const entFromStr = ent => {
   let [type, ...res] = ent.split('/'),
      label = ent

   switch (type) {
      case 'organization':
         let org = OrganizationStore.organization(res.join('/'))

         label = org && org.name ? org.name + ' (Org)' : res.join('/') + ' (Org)'
         break

      case 'user':
         if (ent === (AuthStore.auth || {}).owner) {
            label = 'You (' + res.join('/') + ')'
         } else {
            label = res.join('/')
         }
         break

      default:
   }

   return {
      value: ent,
      label: label,
      type:  type
   }
}

const fetchEntities = (networks, organizations, values) => {
   const entities = _.reduce(
      networks,
      (acc, {parents}) => _.uniq(acc.concat(parents)),
      values || [],
   ),
      orgs = _.reduce(
         organizations,
         (acc, {key, users}) =>
            _.uniq(acc.concat(_.map(users, p => 'user/' + p), 'organization/' + key)),
         entities,
      )

   return _.groupBy(_.map(orgs, entFromStr), 'type')
}

export class AddACL extends React.Component {
   static get propTypes() {
      return {
         network:       React.PropTypes.object,
         networks:      React.PropTypes.array.isRequired,
         organizations: React.PropTypes.array,
         location:      React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         networks:      [],
         organizations: []
      }
   }

   constructor() {
      super()

      this.state = {
         values:    [],
         newValues: [],
         error:     null,
         loading:   null
      }

      this.updateEntities = this.updateEntities.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
   }

   updateEntities(type, patch) {
      let [typed, newElem] = _.partition(patch, e => 1 < e.split('/').length),
         add = typed.concat(_.map(newElem, e => type + '/' + e)),
         {values} = this.state,
         filtered = _.filter(values, e => !e.match(`^${type}/`))

      this.setState({newValues: [], values: _.uniq(filtered.concat(add))})
   }

   // append new entities to `parent`
   handleSubmit(ev) {
      ev.preventDefault()

      const {network} = this.props,
         {key} = network,
         parents = network.parents.concat(this.state.values)

      this.setState({loading: true, error: null, errResource: null})

      return NetworkService.update(key, {parents})
         .then(() => this.setState({loading: false, values: [], newValues: this.state.values}))
         .catch(err => {
            if (err.data) {
               this.setState({
                  loading:     false,
                  error:       err.toString(),
                  errResource: err.data.resource
               })
            } else {
               this.setState({error: err.toString(), loading: false})
            }
         })
   }

   render() {
      const {networks, network, location, organizations} = this.props,
         {values, error} = this.state,
         basepath = location.pathname.split('/').slice(0, -1).join('/')

      const filtered = {
         organizations: _.filter(values, ent => ent.match('^organization/')),
         users:         _.filter(values, ent => ent.match('^user/'))
      }

      const ents = fetchEntities(networks, organizations, values)

      return (
         <div>
            <div className="page-header">
               <h1>Access Control List</h1>
            </div>

            {error && <Alert type="error" message={error} showIcon />}

            <SubmitFeedback network={network} update={this.state.newValues} />

            <Row>
               <Col xs={12} md={6}>
                  <h4>Users</h4>

                  <Select
                     value={filtered.users}
                     onChange={newvals => this.updateEntities('user', newvals)}
                     mode="tags"
                     style={{width: '100%'}}
                  >

                     {_.map(ents.user, ({label, value}) => (
                        <Select.Option key={value} value={value}>{label || value}</Select.Option>
                     ))}
                  </Select>
               </Col>
            </Row>
            <Row>
               <Col xs={12} md={6}>
                  <h4>Organizations</h4>

                  {0 < _.size(ents.organization)
                     ? <Select
                          mode="multiple"
                          value={filtered.organizations}
                          onChange={newvals => this.updateEntities('organization', newvals)}
                          style={{width: '100%'}}
                       >

                          {_.map(ents.organization, ({value, label}) => (
                             <Select.Option key={value} value={value}>
                                {label || value}
                             </Select.Option>
                          ))}
                       </Select>
                     : <Alert
                          type="info"
                          message="You don't have access to any organizations"
                          showIcon
                       />}
               </Col>
            </Row>

            <div style={{marginTop: '1em'}}>
               <p>
                  Add Access Policies to new entities. The entity can be a existing user
                  or a existing organization.
               </p>
               <p>
                  When giving access to an <code>Organization</code> all members
                  of the <code>Organization</code> will get access to the <code>Network</code>
               </p>

               <hr style={{marginTop: '1em', marginBottom: '1em'}} />

               <div className="text-right">
                  <Button
                     loading={this.state.loading}
                     disabled={0 === values.length}
                     type="primary"
                     onClick={this.handleSubmit}
                  >

                     Add {1 < values.length ? values.length + ' entities' : 'entity'}
                  </Button>
                  <Button type="dashed">
                     <Link to={{...location, pathname: basepath}}>
                        <Icon type="close" />
                        Close
                     </Link>
                  </Button>
               </div>
            </div>
         </div>
      )
   }
}

const SubmitFeedback = ({update}) => {
   if (!update || 0 === update.length) {
      return null
   }

   return (
      <Alert
         type="success"
         showIcon
         title="Updated Policies"
         description={
            <p>
               Successfully added {update.length} new Access Policies to network
            </p>
         }
      />
   )
}

SubmitFeedback.propTypes = {
   network: React.PropTypes.object,
   update:  React.PropTypes.array
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/acl/AddACL.jsx